export class LoginResponse {
  token: string;
  dataExpiration: string;
}
export class ErrorAPI {    
  codigo: number;
  mensagem: string;
}
export class historicoRequest
{
    Cedente:number;
    Carteira:number;
    SeuNumero:string;
    NossoNumero:number;
    CPFCNPJSacado:string;
    CPFCNPJBeneficiario:string;
}
export class historicoResponse
{
  titulo:Dados[];
}
export class Dados
{
  cedente:number;
  razaoSocialCedente:string; 
  dtEntrada :string; 
  dtProcessamento:Date; 
  nossoNumero :number; 
  seuNumero :string; 
  especie :string; 
  carteira :number;
  descricaoCarteira:string;
  vlrTitulo :string; 
  tipoPessoaSacado:number; 
  cPFCNPJSacado :string; 
  nomeSacado :string; 
  codigoBanco:number;
  siglaOperacao:string;
} 

export class boletoRequest
{
  cedente:number;
  nossoNumero :number;
  tipoBoleto:number; 
}
export class boletoResponse
{
    linkBoleto:string;
}